import EventStatus from "../../../common/event-status";
import OncePerPlayRule from "../../../common/once-per-play-rule";
import EventService from "../../../../services/event-service";
export default class StartGame extends OncePerPlayRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment },
        event
    ) {
        const eop = super.applicable(
            gameContext,
            ruleContext,
            eventConfiguration,
            {
                play,
                fragment
            },
            event
        );
        const notStarted =
            event?.statusCode !== undefined && !EventStatus.isStarted(event);

        return eop && notStarted;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment },
        event
    ) {
        await EventService.setEventStarted(event.id);
    }
}
